import DirectoryVendors from "../classes/DirectoryVendors";

const state = {
  data: []
};

const getters = {
  vendors: () => {
    return state.data;
  }
};

const actions = {
  directory_vendors_list(state, data) {
    state.commit("setData", data);
  },
  getData(state, variables = {}) {
    return state.rootState.api.query({
      query: require("../../graphql/vendors/vendors_list.graphql"),
      variables: variables
    });
  }
};

const mutations = {
  setData(state, data) {
    state.data = DirectoryVendors.getSelfList(data);
  },
  addFirst(state) {
    state.data.unshift(new DirectoryVendors());
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
